// general tab
export const resourceDetailsGeneralTabProcessKey =
  "resourceDetailsGeneralTabProcessKey";

// costs tab
export const resourceDetailsCostsTabWorkloadNameProcessKey =
  "resourceDetailsCostsTabWorkloadNameProcessKey";
export const resourceDetailsCostsTabProductFamilyProcessKey =
  "resourceDetailsCostsTabProductFamilyProcessKey";
export const resourceDetailsCostsTabUsageTypeProcessKey =
  "resourceDetailsCostsTabUsageTypeProcessKey";
export const resourceDetailsCostsTabItemDescriptionProcessKey =
  "resourceDetailsCostsTabItemDescriptionProcessKey";

export const getResourceDetailsCostsTabAllProcessesKeys = (
  isKubernetes: boolean,
) => {
  const firstItem = isKubernetes
    ? resourceDetailsCostsTabWorkloadNameProcessKey
    : resourceDetailsCostsTabProductFamilyProcessKey;

  return [
    firstItem,
    resourceDetailsCostsTabUsageTypeProcessKey,
    resourceDetailsCostsTabItemDescriptionProcessKey,
  ] as const;
};
